import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title?: string;
    description?: string;
    confirmButtonText?: string;
    isDeleting?: boolean;
};

export function DeleteConfirmationModal({ 
    open, 
    onClose, 
    onConfirm, 
    title = "Are you sure you want to delete this item?",
    description,
    confirmButtonText = "Yes, Delete",
    isDeleting = false
}: Props) {
    return (
        <Dialog open={open} onOpenChange={isDeleting ? undefined : onClose}>
            <DialogContent className="sm:max-w-md z-[200] max-w-[90vw] w-full">
                <DialogHeader>
                    <DialogTitle className="text-center text-lg sm:text-xl font-semibold">
                        {title}
                    </DialogTitle>
                </DialogHeader>

                {description && (
                    <div className="py-4 text-center text-sm text-slate-400">
                        {description}
                    </div>
                )}

                <div className="flex gap-3 pt-2">
                    <Button 
                        variant="secondary" 
                        onClick={isDeleting ? undefined : onClose} 
                        className="flex-1 bg-transparent"
                        disabled={isDeleting}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={isDeleting ? undefined : onConfirm} 
                        className="flex-1" 
                        disabled={isDeleting}
                    >
                        {isDeleting ? <Loader2 className="animate-spin" /> : confirmButtonText}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
